<template>
   
</template>

<script>
import { ConnectionException } from '../../shared/exceptions'
import { Switch as cSwitch } from '@coreui/vue'
import Input from "@/components/form/Input"

export default {
    name: "Inspect",
    components: {
        cSwitch,
        InputField: Input,
    },
    props: {
        model: {
            type: Object,
            default: null
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {}
    },
    computed: {
        show() {
            return this.value
        }
    },
    methods: {
        
    },

    mounted() {}
}
</script>
